import { render, staticRenderFns } from "./ChallengesLaws.vue?vue&type=template&id=c7a32974&"
import script from "./ChallengesLaws.vue?vue&type=script&lang=js&"
export * from "./ChallengesLaws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports